'use client';

import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster data-component-id="src/app/home/components/ToastProvider.tsx:7:4" data-component-path="src/app/home/components/ToastProvider.tsx" data-component-line="7" data-component-end-line="15" data-component-file="ToastProvider.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D"
      position="bottom-right"
      toastOptions={{
        style: {
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '14px',
        },
      }}
    />
  );
}
